import { deepClone, deepMerge } from '@growth/object-utils';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function deepMergeCtaFields(cta1, cta2) {
  if (cta1 === void 0) {
    cta1 = {};
  }
  if (cta2 === void 0) {
    cta2 = {};
  }
  var result = _extends({}, cta1);
  Object.keys(cta2).forEach(function (key) {
    var val1 = result[key];
    var val2 = cta2[key];
    if (typeof val1 === 'object' && val1 !== null && typeof val2 === 'object' && val2 !== null && !Array.isArray(val1) && !Array.isArray(val2)) {
      result[key] = deepMergeCtaFields(val1, val2);
    } else if (typeof val1 === 'string' || typeof val2 === 'string' || val1 == null || val2 == null) {
      var str1 = val1 == null ? '' : String(val1);
      var str2 = val2 == null ? '' : String(val2);
      result[key] = [str1, str2].join('|');
    } else if (val2 !== undefined) {
      result[key] = val2;
    }
  });
  return result;
}
function mergeEventObjectsWithCta(obj1, obj2) {
  var result = _extends({}, obj1);
  Object.keys(obj2).forEach(function (key) {
    if (key === 'cta') {
      result.cta = deepMergeCtaFields(obj1.cta, obj2.cta);
      result.cta.type = "itemLoad";
    } else {
      result[key] = obj2[key]; // last value wins, no concat
    }
  });

  return result;
}
var mergeEvents = function mergeEvents(eventsArray) {
  if (!eventsArray || eventsArray.length === 0) return undefined;
  if (eventsArray.length === 1) return eventsArray[0];
  return eventsArray.slice(1).reduce(function (acc, curr) {
    return mergeEventObjectsWithCta(acc, curr);
  }, eventsArray[0]);
};
var isLoadEvent = function isLoadEvent(eventObj) {
  var _eventObj$cta;
  if (eventObj.event === 'ctaClick' && (_eventObj$cta = eventObj.cta) != null && (_eventObj$cta = _eventObj$cta.type) != null && _eventObj$cta.toLowerCase().includes('load')) {
    return true;
  }
  return false;
};

var config = {
  adobeDataLayer: []
};
var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
    section = _ref.section,
    lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};
var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';
  var configs = _extends({}, pluginConfig);
  var init = function init() {
    var _window$top, _window$top4;
    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }
    if (window.top && !((_window$top = window.top) != null && _window$top.adobeLoadEvent)) {
      var _window;
      window.top.adobeLoadEvent = {
        sent: false,
        value: []
      };
      var sendLoadEvents = function sendLoadEvents() {
        var _window$top2, _window$top3;
        if ((_window$top2 = window.top) != null && (_window$top2 = _window$top2.adobeLoadEvent) != null && _window$top2.sent) {
          // if events are already sent, don't send again
          return;
        }
        if ((_window$top3 = window.top) != null && _window$top3.adobeLoadEvent) {
          // if adobeLoadEvent object is present, then merge the events
          window.top.adobeLoadEvent.sent = true;
          var mergedEvents = mergeEvents(window.top.adobeLoadEvent.value);
          if (mergedEvents && config.adobeDataLayer) {
            // if mergedEvents are present, then push the events to the dataLayer
            config.adobeDataLayer.push(mergedEvents);
          }
        }
      };
      var timerId = setTimeout(function () {
        timerId = undefined;
        sendLoadEvents();
      }, 2000);
      var handleBeforeUnload = function handleBeforeUnload() {
        if (timerId) {
          clearTimeout(timerId);
          sendLoadEvents();
        }
      };
      (_window = window) == null || _window.addEventListener('beforeunload', handleBeforeUnload);
    }
    config.adobeDataLayer = (_window$top4 = window.top) == null ? void 0 : _window$top4.adobeDataLayer;

    // return the created window dataLayer. Helps in testing
    return config.adobeDataLayer;
  };
  var track = function track(_ref2) {
    var payload = _ref2.payload;
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _window$top5;
      var formattedPayload = deepClone(_extends({}, configs));
      deepMerge(payload.eventProperties, formattedPayload);
      if (debug) {
        console.log('track payload ', _extends({
          event: payload.event
        }, formattedPayload));
      }
      // since ctaclick all the parameters are mandatory i.e. why adding check here
      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      }
      var aobePayload = _extends({
        event: payload.event
      }, formattedPayload);
      if (isLoadEvent(aobePayload) && (_window$top5 = window.top) != null && _window$top5.adobeLoadEvent && !window.top.adobeLoadEvent.sent) {
        window.top.adobeLoadEvent.value.push(aobePayload);
      }
      // don't push the event if adobe script is not present
      else if (config.adobeDataLayer) config.adobeDataLayer.push(aobePayload);
      return formattedPayload;
    }
    return {};
  };
  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
        _ref3$eventProperties = _ref3.eventProperties,
        eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;
      var formattedPayload = _extends({}, pluginConfig);
      deepMerge(eventProperties, formattedPayload);
      // updating the global config data with every pageView Data
      configs = _extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }
    return {};
  };
  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};

export { AnalyticsPluginAdobe as default };
